<app-input-dialog #exportExcelDialog title="Downloads">
    <input-dialog-step button="">
        <p>{{ exportProgressMessage }}</p>
        <ngb-progressbar [striped]="true" [animated]="true" [value]="exportProgress"></ngb-progressbar>
    </input-dialog-step>
</app-input-dialog>
<iframe class="d-none" [src]="exportDownloadURL | safe: 'resourceUrl'"></iframe>